import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as api from '../../utils/api';
import * as MedlemsAdfaerdService from '@Utils/medlemsAdfaerdService';
import Content from '../../components/Content';
import Receipt from '../../components/Receipt';
import { TModal, TCurrentBlock, TInput } from '../../utils/types';
import ConsentModal from '../../components/ConsentModal';
import Grid from '../../components/Grid';

export interface WelcomeProps {
  propsData: {
    samtykkeLabel?: string
    samtykkeTekst?: string
    samtykke: boolean
    visSalaryStep?: boolean
	adgangTilFlow?: boolean
	adgangTilKontaktFlow?: boolean
    velkomstEpiserverId: string
    currentBlock: TCurrentBlock[]
  }
  inputData: TInput
  setInputData: (inputData: TInput) => void
}

const Welcome = ({ propsData, inputData, setInputData }: WelcomeProps) => {
	const { currentBlock, samtykkeLabel, samtykkeTekst, samtykke, visSalaryStep, adgangTilFlow, adgangTilKontaktFlow, velkomstEpiserverId } = propsData;
	const history = useHistory();
	const [showForm, setShowForm] = useState(true);
	const [showEmailonlyForm, setShowEmailonlyForm] = useState(false);
	const [formSubmitted, setFormSubmitted] = useState(false);
	const [showReceipt, setShowReceipt] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [showConsent, setShowConsent] = useState(false);
	const [consentFromModal, setConsentFromModal] = useState(false);
	const [showSalaryReceipt, setShowSalaryReceipt] = useState(false);
	const [showReceiptFinal, setShowReceiptFinal] = useState(false);
	const [modalData, setModalData] = useState({} as TModal);
	const [showSalaryContent, setShowSalaryContent] = useState(visSalaryStep);

	const objdata: {[key:string]: string} = {};

	currentBlock.forEach((e: {name: string, value: string}) => {
		const { name, value } = e;
		objdata[name] = value;
	});

	const handleModalVisibility = () => {
		setShowModal(false);
	};

	const handleContentSkip = () => {
		api.createEvent(velkomstEpiserverId, objdata['HaendelseKontaktoplysninger']);
		setModalData({
			modalHeader: objdata['SkipTitle'],
			modalText: objdata['SkipSamtykkeText'],
			modalBtnText1: objdata['BackButtonText'],
			modalBtnText2: objdata['SkipButtonText'],
			salaryContent: false
		});
		setShowModal(true);
		setShowConsent(false);
	};

	const handleSalaryContentSkip = () => {
		api.createEvent(velkomstEpiserverId, objdata['HaendelseLoen']);
		setModalData({
			modalHeader: objdata['SkipTitle'],
			modalText: objdata['SkipSalaryText'],
			modalBtnText1: objdata['BackButtonText'],
			modalBtnText2: objdata['SkipButtonText'],
			salaryContent: true
		});
		setShowModal(true);
		setShowConsent(false);
	};

	const handleConsentClick = () => {
		setShowModal(true);
		setShowConsent(true);
	};

	const handleSubmittedSkip = () => {
		api.createEvent(velkomstEpiserverId, objdata['HaendelseSamtykke']);
		MedlemsAdfaerdService.gemInteraktion('SamtykkeSpringOver', objdata['BaseInteraktionDialogId'], '', 'WEB');
		setShowReceipt(false);
		setShowReceiptFinal(true);
	};

	const handleFinalClick = () => {
		setShowReceipt(false);
		setShowReceiptFinal(true);
	};

	const handleMailModalClick = () => {
		if (inputData.email) {
			setModalData({
				modalHeader: objdata['MailTitleHvisMailFindes'],
				modalText: objdata['MailTxtHvisMailFindes'],
				modalBtnText1: objdata['OkButtonText'],
				modalBtnText2: null
			});
			MedlemsAdfaerdService.gemInteraktion(objdata['BaseInteraktionDialogId'] + 'ServicetjekPåMail', objdata['BaseInteraktionDialogId'], '', 'WEB');
			setShowEmailonlyForm(false);
		} else {
			setModalData({
				modalHeader: objdata['MailTitleHvisMailIkkeFindes'],
				modalText: objdata['MailTxtHvisMailIkkeFindes'],
				modalBtnText1: objdata['OkButtonText'],
				modalBtnText2: null
			});
			setShowEmailonlyForm(true);
		}
		setShowConsent(false);
		setShowModal(true);
	};

	const handleGoToChaptersClick = (e: { preventDefault: () => void }) => {
		MedlemsAdfaerdService.gemInteraktion('ServicetjekStart', objdata['BaseInteraktionDialogId'], '', 'WEB');
		e.preventDefault();
		history.push('kapitel/1');
	};

	useEffect(() => {
		if (formSubmitted) {
			setShowForm(false);

			if (objdata['ServicetjekType'] === 'Kontaktinformation') {
				if (samtykke) {
					setShowReceipt(true);
				} else {
					MedlemsAdfaerdService.gemInteraktion('ServicetjekStart', objdata['BaseInteraktionDialogId'], '', 'WEB');
					history.push('kapitel/1');
				}
			} else {
				setShowReceipt(true);
			}
		}
	}, [formSubmitted]);

	useEffect(() => {
		api.createCaseLST();
	}, []);

	const contentProps = {
		objdata,
		inputData,
		samtykkeLabel,
		showForm,
		velkomstEpiserverId,
		setInputData,
		setFormSubmitted,
		handleContentSkip,
		setShowSalaryReceipt,
		setShowModal
	};

	const receiptProps = {
		objdata,
		inputData,
		adgangTilFlow,
		adgangTilKontaktFlow,
		showReceipt,
		showReceiptFinal,
		consentFromModal,
		showEmailonlyForm,
		showSalaryContent,
		showSalaryReceipt,
		samtykkeLabel,
		velkomstEpiserverId,
		handleConsentClick,
		handleSubmittedSkip,
		handleFinalClick,
		handleGoToChaptersClick,
		handleMailModalClick,
		handleSalaryContentSkip,
		setInputData,
		setFormSubmitted,
		setShowSalaryReceipt,
		setShowModal
	};

	const modalProps = {
		objdata,
		modalData,
		showConsent,
		inputData,
		showEmailonlyForm,
		samtykkeTekst,
		samtykkeLabel,
		velkomstEpiserverId,
		handleModalVisibility,
		setShowForm,
		setInputData,
		setFormSubmitted,
		setShowModal,
		setShowReceipt,
		setShowSalaryContent,
		setConsentFromModal
	};

	return (
		<Grid element="section" className="page new">
			<Content { ...contentProps } />
			<Receipt { ...receiptProps } />
			{ showModal &&
				<ConsentModal { ...modalProps } /> }
		</Grid>
	);
};

export default Welcome;